module.exports = __webpack_public_path__ + "img/IMG_1864.c7142ad5.jpg";